// Hungarian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `elérhető eddig: ${date}` : ''),
    },
    interview: {
      title: 'Válasz a videó interjúra',
      submit: 'Válaszok küldése és interjú elkészítése',
      continueLater: 'Folytatás később',
      startInterview: 'Interjú indítása',
      duplicateError: 'Már részt vett ebben az interjúban. Kapott egy e-mailt innen: invitations@recright.com, ami tartalmazza az interjú folytatásához szükséges linket.',
      confirmSubmitHeader: 'Még nem válaszolt az interjú minden kérdésére',
      confirmSubmitContent: 'Valóban be akarja fejezni az interjút?',
      confirmSubmitContentWarning: 'Ha most befejezi, már nem lesz lehetősége további válaszadásra.',
      submitInterviewHeader: 'Küldje el válaszait az interjúhoz',
      submitInterviewContent: 'Biztos, hogy be akarja küldeni az interjúját?',
      confirmSubmitButton: 'Válaszok küldése és interjú elkészítése',
      preview: 'Itt tekintheti meg a videó interjú kérdéseit.',
      withdrawLink: 'Már nem érdekli ez az állás? Itt léphet ki a folyamatból.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Név',
      city: 'Lakóhely szerinti város',
      email: 'E-mail',
      phone: 'Telefonszám',
      link: 'Hivatkozás',
      legendBasicInfo: 'Alapinformációk',
      placeholderName: 'Adja meg a nevét',
      placeholderEmail: 'Adja meg e-mail címét.',
      placeholderPhone: 'Adja meg telefonszámát.',
      placeholderCity: 'Adja meg jelenlegi lakhelyét',
      placeholderLink: 'Adjon hozzá linket, például Linkedin profilját.',
      legendAttachments: 'Csatolmányok',
      legendAdditionalFields: 'További információk',
      required: 'A * csillaggal jelzett mezők kitöltése kötelező.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audió',
        video: 'Videó',
        yes: 'Igen',
        no: 'Nem',
        supported: 'Támogatott',
        quality: 'Minőség',
        header: 'Hálózati kapcsolat és eszköz ellenőrzése',
        description: 'Most lefuttatunk egy tesztet, amely ellenőrzi az interjúhoz szükséges hálózati kapcsolatának és hardverének (kamera és mikrofon) megfelelő működését. Amikor megjelenik a kérés, kérjük, engedélyezze, hogy a teszt használhassa mind a kameráját, mind a mikrofonját, és győződjön meg arról, hogy a kamera nincs letakarva. A teszt körülbelül 30 másodpercig fog tartani. Javasoljuk, hogy a hardver tesztelése során beszéljen.',
        inProgress: 'Teszt folyamatban...',
        networkTestResults: 'Hálózati teszt eredményei',
        qualityTestResults: 'Minőségi teszt eredményei',
        testPassedQuality: 'Uspješna provjera kvalitete',
        testFailedQuality: 'Neuspješna provjera kvalitete',
        testPassedNetwork: 'Uspješna provjera mreže',
        testFailedNetwork: 'Neuspješna provjera mreže',
        startTest: 'Teszt indítása',
        startInterview: 'Interjú indítása',
        testAgain: 'Teszt megismétlése',
        confirmWarning: 'A videointerjú elindításakor automatikusan megjelenik az interjú első kérdése. A kérdés megtekintése után a rendszer továbblépteti Önt a felkészülési szakaszhoz.',
        confirmTitle: 'Az interjú hamarosan kezdődik',
        confirmText: 'Minden kérdés megválaszolása előtt rendelkezésére áll egy rövid felkészülési idő. A felkészülést követően a megadott időn belül kell megválaszolnia a kérdést. Válaszát bármikor beküldheti, nem kell megvárnia a válaszadásra rendelkezésre álló idő leteltét.',
        confirmText2: 'Válasza beküldése után mindaddig megjelenik a következő kérdés, amíg el nem fogynak a kérdések.',
        confirmText3:
          'Felhívjuk figyelmét, hogy egy kérdésre adott válasz rögzítése után 30 másodperces időablak áll rendelkezésére a válasz megismétlésére, ha az ismétlés engedélyezett. Ha nem kezdeményezi az ismétlést ezen a 30 másodperces időkereten belül, az aktuális válasza automatikusan továbbítódik, és Önt a következő kérdésre irányítjuk.',
        goodLuck: 'Vegyen egy mély levegőt, és vágjon bele! Sok szerencsét!',
        qualityRating: {
          excellent: 'Kiváló',
          good: 'Jó',
          fair: 'Megfelelő',
          poor: 'Gyenge',
          bad: 'Rossz',
        },
      },
      questionAnswerView: {
        title: title => `Válasz az interjú kérdéseire ${title}`,
        question: 'Kérdés',
        submitAndNext: 'Beküldés és ugrás a következő kérdésre',
        submitSuccess: 'A videó beküldése sikeresen megtörtént!',
        skipText: 'Felvétel indítása',
        stop: 'Megállítás',
        submitAndFinish: 'Interjú beküldése és befejezése',
        retake: 'Interjú megismétlése',
        take: 'Interjú elvégzése',
        takesLeft: 'Hátralévő lehetőségek',
        skipTextQuestion: 'Készen van? Haladjon tová',
        retakeConfirmTitle: 'Biztosan megismételi a válaszát erre a kérdésre?',
        retakeConfirmSubmit: 'Igen, ismétlés',
        submitInfoForward: 'Az aktuális válasz automatikus elküldése és továbblépés',
        submitInfoForward2: 'másodpercen belül',
        nonAnswerableText: 'Erre az üzenetre nem szükséges válaszolnia. Az üzenetet követően továbbléptetjük a közvetlenül a következő kérdésre.',
        nonAnswerableVideo: 'Erre a videóra nem szükséges válaszolnia. A videó után továbbléptetjük közvetlenül a következő kérdésre.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `A kérdés megválaszolására ${answerMinutes} perc és ${answerSeconds} másodperc áll a rendelkezésére.`,
      },
      publisher: {
        toNextQuestion: timer => `Tovább a következő kérdésre ekkor ${timer}`,
        recordingStarts: timer => `A rögzítés kezdete ekkor ${timer}`,
      },
      errors: {
        tooManyConnections: 'Ezt a kapcsolatot bezártuk, mert ön egy másik fülön vagy ablakban már csatlakozott.',
        unsupportedBrowser: 'Böngészője sajnos nem támogatja ezt a műveletet. Kérjük, használjon másik böngészőt.',
        networkError: 'Nincs internetkapcsolat.',
        reconnecting: 'A kapcsolat megszakadt. Újracsatlakozás folyamatban.',
        generalError: 'Hiba történt. Kérjük, frissítse az oldalt, és próbálkozzon újra.',
        allowMediaDevicesError: 'A műveletnek nem sikerült hozzáférnie a médiaeszközökhöz (kamera vagy mikrofon). Kérjük, győződjön meg arról, hogy engedélyezte a böngésző beállításaiban a kamera és a mikrofon használatát.',
        noAvailableDevicesError: 'Nem található kamera vagy mikrofon.',
        initPublisherError: 'A művelet hiba miatt nem sikerült. Kérjük, győződjön meg arról, hogy engedélyezte a böngészőnek a kamera és a mikrofon használatát, és hogy azokat nem használja másik alkalmazás, majd próbálkozzon újra.',
      },
      browserInfo: {
        browserSupportTitle: 'Böngészőtámogatás',
        supportedBrowsers: 'Ez a teszt és az interjú a Chrome, Firefox, Safari és az Edge legfrissebb verzióival kompatibilis.',
        mobileSupported: 'Mobileszközök támogatott böngészői',
        android: 'Android: Google Chrome (legújabb verzió), Firefox (legújabb verzió)',
        iOS: 'iOS: Safari (legújabb verzió)',
        latestVersion: 'Kérjük, győződjön meg arról, hogy a böngésző legújabb verzióját használja. Erre azért van szükség, hogy minden zökkenőmentesen menjen.',
        freezeInstruction: 'Ha a videofelvétel nem indul el, vagy a felvételi képernyő fekete marad, frissítse az oldalt.',
        unsupportedOnIos: 'Úgy tűnik, hogy az iOS által nem támogatott böngészőt próbál használni. Kérjük, használja a Safarit.',
        ieUnsupported: 'Úgy tűnik, az Internet Explorert próbálja használni. Az Internet Explorer böngésző sajnos nem kompatibilis ezzel a teszttel vagy interjúval. Kérjük, válasszon másik böngészőt.',
        qualityTestNotSupported: 'Az Ön által használt böngésző sajnos nem támogatja a hardver tesztelését. Továbbléphet az interjúhoz a hang és a kép minőségének tesztelése nélkül, vagy használhat egy másik böngészőt.',
      },
      reconnectSuccess: 'Az újracsatlakozás sikerült.',
      continue: 'Folytatás',
    },

    withdraw: {
      title: 'Már nem érdekli ez az állás?',
      description: 'Lépjen ki a felvételi folyamatból.',
      buttonText: 'Kilépés a felvételi folyamatból',
      thankYouTitle: 'Köszönjük!',
      thankYouText: 'Ezzel a felvételi személyzet tudomására hozta, hogy már nem érdekli Önt az állás.',
      confirm: 'Biztosan ki szeretne lépni a felvételi folyamatból? A kilépést követően már nem lesz lehetősége válaszolni erre, vagy más, a jelen álláshoz kapcsolódó interjúra.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Elküldés',
      continue: 'Folytatás',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Köszönjük videó válaszát! >Hamarosan felvesszük Önnel a kapcsolatot!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Köszönjük, hogy részt vett az interjúban!',
      reopenDescription: 'Ne aggódjon, ha véletlenül bezárta az interjút! Az alábbi gombra kattintva ismét megnyithatja az interjút!',
      reopenButtonText: 'Interjú ismételt megnyitása',
      description1: 'Nagyszerű! Minden kérdést megválaszolt, és továbbítottuk a címzettnek.',
      descriptionsupport: mailto => `Ha véletlenül zárta be az interjút, kérjük, lépjen kapcsolatba ügyfélszolgálatunkkal ${mailto} és ismét elérhetővé tesszük.`,
      descriptionfeedback: 'Tapasztalata fontos számunkra! Milyen tapasztalatai voltak a videó interjú megválaszolása során? Miben javítana szolgáltatásunkon? Adjon visszajelzést itt.',
      feedbackbutton: 'Itt adjon visszajelzést nekünk!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Személyes üzenet',
    },

    closed: {
      title: 'Az interjú készen van, vagy véget ért',
      description: 'A meghívóval elérhető videó interjú már véget ért, vagy befejezte annak benyújtását.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Videó interjúdat elmentettük!',
      description: 'Amikor folytatni szeretné a videó interjút, használja a korábban kapott e-mailen szereplő linket. A korábban rögzített videó válaszait akkor is megtalálja, ha később visszatér! Sok sikert az álláskereséshez!',
      remember: 'Ne feledje elküldeni válaszait a munkaerő-toborzónak miután válaszolt az interjú kérdéseire.',
      deleteHistory: 'Ha az interjút nyilvános számítógépen készíti el, ne feledje törölni a böngészési előzményeket. Ezzel védheti az interjú biztonságát.',
    },
    unpublished: {
      title: 'Az interjút még nem nyitotta meg',
      publishTime: publishTime => `Az interjú ekkor nyílik meg ${publishTime}`,
    },
  },
}
